import styled from 'styled-components';
import { _m, _mx, _my, _mt, _mr, _mb, _ml, _mbs, _mie, _mbe, _mis, _mbl, _mi } from './core';
export function m(values) {
    return function({ theme }) {
        return _m(values, theme);
    };
}
export function mx(values) {
    return function({ theme }) {
        return _mx(values, theme);
    };
}
export function my(values) {
    return function({ theme }) {
        return _my(values, theme);
    };
}
export function mt(values) {
    return function({ theme }) {
        return _mt(values, theme);
    };
}
export function mr(values) {
    return function({ theme }) {
        return _mr(values, theme);
    };
}
export function mb(values) {
    return function({ theme }) {
        return _mb(values, theme);
    };
}
export function ml(values) {
    return function({ theme }) {
        return _ml(values, theme);
    };
}
export function mbs(values) {
    return function({ theme }) {
        return _mbs(values, theme);
    };
}
export function mie(values) {
    return function({ theme }) {
        return _mie(values, theme);
    };
}
export function mbe(values) {
    return function({ theme }) {
        return _mbe(values, theme);
    };
}
export function mis(values) {
    return function({ theme }) {
        return _mis(values, theme);
    };
}
// We already got a mixin `mb` which stands for margin-bottom. So we are using `mbl` which stands for logical margin-block.
export function mbl(values) {
    return function({ theme }) {
        return _mbl(values, theme);
    };
}
export function mi(values) {
    return function({ theme }) {
        return _mi(values, theme);
    };
}
export const Margin = styled.div.attrs({
    'data-mesh-component': 'MARGIN'
})`
  ${({ inline })=>inline && 'display: inline-block;'}
  ${({ all, theme })=>all && _m(all, theme)}
  ${({ horizontal, theme })=>horizontal && _mx(horizontal, theme)} 
  ${({ vertical, theme })=>vertical && _my(vertical, theme)} 
  ${({ top, theme })=>top && _mt(top, theme)} 
  ${({ right, theme })=>right && _mr(right, theme)} 
  ${({ bottom, theme })=>bottom && _mb(bottom, theme)} 
  ${({ left, theme })=>left && _ml(left, theme)}

  ${({ blockStart, theme })=>blockStart && _mbs(blockStart, theme)} 
  ${({ inlineEnd, theme })=>inlineEnd && _mie(inlineEnd, theme)} 
  ${({ blockEnd, theme })=>blockEnd && _mbe(blockEnd, theme)} 
  ${({ inlineStart, theme })=>inlineStart && _mis(inlineStart, theme)}

  ${({ block, theme })=>block && _mbl(block, theme)} 
  ${({ inline, theme })=>inline && _mi(inline, theme)}
`;
Margin.displayName = 'Margin';

//# sourceMappingURL=Margin.js.map